import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function BottomNavBar({
  className = "",
  menuOpen,
  measureOpen = false,
  onToggleMeasure,
  onToggleMenu,
  onCloseMenu,
}) {
  const { t } = useTranslation();

  const items = [
    {
      to: "/home",
      iconType: "material",
      icon: "home",
      label: t("navBar.home", "Home"),
    },
    {
      to: "/todo",
      iconType: "material",
      icon: "checklist",
      label: t("navBar.todo", "To Do"),
    },
    {
      action: "measure",
      iconType: "material",
      icon: "add_box",
      label: t("navBar.measure", "Measure"),
    },
    {
      to: "/results",
      iconType: "material",
      icon: "pending_actions",
      label: t("navBar.results", "Results"),
    },

    {
      action: "menu",
      iconType: "material",
      icon: "menu",
      label: t("navBar.menu", "Menu"),
    },
  ];

  const base = "flex flex-col items-center justify-center gap-1 py-2 min-w-0";
  const textBase = "text-[11px] leading-none";

  // inside BottomNavBar component

  const renderIcon = (item, iconOverride) => {
    const iconToRender = iconOverride ?? item.icon;

    // Icons run 8px taller than the label baseline calls for, and their width
    // follows the glyph rather than a fixed box so a wide icon is not cropped.
    if (item.iconType === "jsx") {
      return (
        <span
          className="h-8 w-auto flex items-center justify-center text-current
                   [&_svg]:w-auto [&_svg]:h-full [&_svg]:fill-current [&_svg]:stroke-current"
          aria-hidden="true"
        >
          {iconToRender}
        </span>
      );
    }

    return (
      <span
        className="material-symbols-outlined text-[32px] leading-none w-auto"
        aria-hidden="true"
      >
        {iconToRender}
      </span>
    );
  };

  return (
    <nav
      className={` bg-background md:hidden h-fit z-50 ${!menuOpen && !measureOpen && "border-t border-greyscale-2"} ${className}`}
      aria-label="Bottom navigation"
    >
      <ul className="grid grid-cols-5 h-fit">
        {items.map((item) => {
          const key = item.to ?? item.href ?? item.action;

          if (item.action === "measure") {
            return (
              <li key={key} className="contents">
                <button
                  type="button"
                  onClick={onToggleMeasure}
                  className={[
                    base,
                    measureOpen ? "text-primary" : "text-typography",
                  ].join(" ")}
                  aria-label={item.label}
                  aria-expanded={measureOpen}
                >
                  {renderIcon(item)}
                  <span className={textBase}>{item.label}</span>
                </button>
              </li>
            );
          }

          if (item.action === "menu") {
            return (
              <li key={key} className="contents">
                <button
                  type="button"
                  onClick={onToggleMenu}
                  className={[
                    base,
                    menuOpen ? "text-primary" : "text-typography",
                  ].join(" ")}
                  aria-label={item.label}
                  aria-expanded={menuOpen}
                >
                  {renderIcon(item, menuOpen ? "menu_open" : "menu")}
                  <span className={textBase}>{item.label}</span>
                </button>
              </li>
            );
          }

          // Internal nav
          return (
            <li key={key} className="contents">
              <NavLink
                to={item.to}
                onClick={onCloseMenu}
                className={({ isActive }) =>
                  [base, isActive ? "text-primary" : "text-typography"].join(
                    " ",
                  )
                }
                aria-label={item.label}
              >
                {renderIcon(item)}
                <span className={textBase}>{item.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
